// borrowerSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../services/AxiosInstance";

// Create an async thunk to fetch borrower data
export const fetchborrowerData = createAsyncThunk(
  "borrower/fetchborrowerData",
  async () => {
    try {
      const response = await axiosInstance.get("borrower");
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

const borrowerSlice = createSlice({
  name: "borrower",
  initialState: {
    data: [],
    borrowerCount: 0,
    loading: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchborrowerData.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchborrowerData.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.data = action.payload;
        state.borrowerCount = action.payload.length;
      })
      .addCase(fetchborrowerData.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      });
  },
});

export default borrowerSlice.reducer;
